import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { KendoModule } from '@shared/kendo.module';
import { MaterialModule } from '@shared/material.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SharedModule } from '../shared/shared.module';

import { LoginPage } from '@pages/auth/login.page';
import { AppInitializationPage } from '@pages/auth/app-initialization.page';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { PasswordRecoveryFormComponent } from './components/password-recovery-form/password-recovery-form.component';
import { ExclusiveFormFieldDirective } from './directives/exclusive-form-field.directive';
import { ShowcaseCarouselComponent } from './components/showcase-carousel/showcase-carousel.component';
import { AccessCodeFormComponent } from './components/access-code-form/access-code-form.component';
import { FormNotificationComponent } from './components/form-notification/form-notification.component';
import { MfaComponent } from './components/mfa/mfa-settings.component';
import { SetPasswordComponent } from '@pages/auth/set-password/set-password.component';
import { SetPreferences } from './components/mfa/set-preferences/set-preferences.component';
import { ForgotUseridComponent } from './components/forgot-userid/forgot-userid.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    LoginPage,
    AppInitializationPage,
    LoginFormComponent,
    PasswordRecoveryFormComponent,
    ExclusiveFormFieldDirective,
    ShowcaseCarouselComponent,
    AccessCodeFormComponent,
    FormNotificationComponent,
    MfaComponent,
    SetPasswordComponent,
    SetPreferences,
    ForgotUseridComponent
  ],
  imports: [
    SharedModule,
    CarouselModule,
    CommonModule,
    HttpClientModule,
    KendoModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    MatStepperModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ]
})
export class AuthModule { }
